import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { hydeParkConfig } from "./data";

export default function HydeParkPage() {
  return <CityPageTemplate config={hydeParkConfig} />;
}